import { render, staticRenderFns } from "./CommonUpload.vue?vue&type=template&id=85fd9090"
import script from "./CommonUpload.vue?vue&type=script&lang=js"
export * from "./CommonUpload.vue?vue&type=script&lang=js"
import style0 from "./CommonUpload.vue?vue&type=style&index=0&id=85fd9090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports